import { sortBy, toNumber } from 'lodash-es';
import type { CiteKnowledge, SourceKnowledge } from 'services/api/supplementKnowledge';

export const transformKnowledge = (
  citeKnowledge: CiteKnowledge[],
  sourceKnowledge: SourceKnowledge[],
) => {
  return sortBy(
    citeKnowledge.reduce(
      (res, knowledge) => {
        let target = sourceKnowledge.find(
          ({ knowledgeId }) => knowledgeId === knowledge.knowledgeId,
        );
        if (knowledge.source === '商品详情页') {
          const sourceTarget = sourceKnowledge.find(
            ({ sourceId }) => `${sourceId}` === `${knowledge.knowledgeId}`,
          );
          if (sourceTarget) {
            target = sourceTarget;
          }
        }
        if (
          !target ||
          ((knowledge.knowledgeId as any as string)?.startsWith('test') && !target.kvId)
        ) {
          return res;
        }
        res.push({
          citeKnowledge: knowledge,
          sourceKnowledge: target,
        });
        return res;
      },
      [] as {
        citeKnowledge: CiteKnowledge;
        sourceKnowledge: SourceKnowledge;
      }[],
    ),
    ({ citeKnowledge }) => -toNumber(citeKnowledge.score),
  );
};
